import { useState, useMemo } from "react";
import LadderItem from "./LadderItem";
import useElectionsData from "../../hooks/useElectionsData";

function Ladder() {
  const electionsData = useElectionsData();
  const ladderData = useMemo(prepareLadderData, [electionsData]);
  const [currentDate] = useState(
    new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(new Date())
  );

  function prepareLadderData() {
    const lastTenDataPoints = electionsData.sheetData.slice(-10);
    lastTenDataPoints.sort((currentElement, nextElement) => {
      return (
        Number(nextElement.Probability) - Number(currentElement.Probability)
      );
    });
    return lastTenDataPoints;
  }

  if (!ladderData.length) return null;

  return (
    <div className="us-elections-widget__ladder">
      <p>
        Current stats for <span>{currentDate}</span>
      </p>
      <ul>
        {ladderData.map((sheetDataPoint, index) => {
          return (
            <LadderItem
              key={index}
              index={index}
              sheetDataPoint={sheetDataPoint}
            />
          );
        })}
      </ul>
    </div>
  );
}

export default Ladder;
